/* ==========================================================================
   EASE CUSHION — landing page add to cart
   Adds with the Cart AJAX API, animates the button, then opens the store's
   EXISTING cart drawer. It never navigates to /cart and never builds a
   drawer of its own.

   If the drawer doesn't open by itself, set the selector of the element that
   opens it, once, anywhere before this script runs (theme.liquid is fine):

       <script>window.EC_CART_TRIGGER = '.your-cart-drawer-button';</script>

   or add  data-ec-cart-trigger  to that element in the theme.
   Set  window.EC_CART_DEBUG = true  to log what was tried in the console.
   ========================================================================== */
(function () {
  if (window.__ecCartCTA) return;
  window.__ecCartCTA = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Elements that open the cart drawer, most specific first.
  var TRIGGERS = [
    '[data-ec-cart-trigger]',
    '[aria-controls="cart-drawer"]',
    '[data-action="open-drawer"][aria-controls*="cart" i]',
    '[aria-controls*="cart" i]',
    '[data-cart-drawer-toggle]',
    '[data-drawer-toggle="cart"]',
    '[data-action="open-cart"]',
    '#cart-icon-bubble',
    '#CartDrawer-Trigger',
    '.js-drawer-open-right',
    '.js-cart-drawer-open',
    '.cart-drawer-toggle',
    '.header__icon--cart',
    '.header__cart'
  ];

  function log() {
    if (window.EC_CART_DEBUG && window.console) {
      console.log.apply(console, ['[Ease Cushion cart]'].concat([].slice.call(arguments)));
    }
  }

  function fire(name, detail) {
    document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }

  function theDrawer() {
    return document.querySelector('cart-drawer, #cart-drawer, cart-notification, #CartDrawer');
  }

  function drawerIsOpen() {
    var d = theDrawer();
    if (!d) return false;
    if (d.hasAttribute('open') || d.classList.contains('is-open') || d.classList.contains('active')) return true;
    var cs = window.getComputedStyle(d);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.1;
  }

  // Ask the theme to reload the drawer's contents — we added with fetch, so it
  // doesn't know about the new line item yet.
  function refreshDrawerContents(json) {
    ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build', 'ajaxProduct:added']
      .forEach(function (n) { fire(n, json); });
  }

  /* ---------------------------------------------- open the store's drawer */

  function openExistingDrawer(json) {
    // 1. A selector you set yourself always wins.
    if (window.EC_CART_TRIGGER) {
      var custom = document.querySelector(window.EC_CART_TRIGGER);
      if (custom) { custom.click(); log('opened via EC_CART_TRIGGER', window.EC_CART_TRIGGER); return; }
      log('EC_CART_TRIGGER set but not found:', window.EC_CART_TRIGGER);
    }

    var drawer = theDrawer();
    refreshDrawerContents(json);

    // 2. The drawer element's own API, then its `open` attribute.
    if (drawer) {
      var methods = ['show', 'open', 'showModal', 'openDrawer'];
      for (var m = 0; m < methods.length; m++) {
        if (typeof drawer[methods[m]] === 'function') {
          try {
            drawer[methods[m]]();
            log('opened cart-drawer via .' + methods[m] + '()');
            window.setTimeout(function () { refreshDrawerContents(json); }, 80);
            return;
          } catch (e) { log('.' + methods[m] + '() failed', e); }
        }
      }
      if (!drawer.hasAttribute('open')) {
        drawer.setAttribute('open', '');
        log('opened cart-drawer via the open attribute');
        window.setTimeout(function () { refreshDrawerContents(json); }, 80);
        return;
      }
    }

    // 3. Cart apps with their own drawer.
    try {
      if (typeof window.SLIDECART_OPEN === 'function') { window.SLIDECART_OPEN(); log('opened SlideCart'); return; }
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.open === 'function') {
        window.Rebuy.SmartCart.open(); log('opened Rebuy'); return;
      }
      if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
        window.theme.cartDrawer.open(); log('opened theme.cartDrawer'); return;
      }
    } catch (e) { log('cart app API failed', e); }

    // 4. Click whatever opens the drawer in the header.
    for (var i = 0; i < TRIGGERS.length; i++) {
      var el = document.querySelector(TRIGGERS[i]);
      if (el) { el.click(); log('clicked trigger', TRIGGERS[i]); return; }
    }
    log('no way to open the drawer found — set window.EC_CART_TRIGGER');
  }

  /* -------------------------------------------------------- cart badges */

  function refreshCount() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        fire('cart:quantity-updated', cart);
        document
          .querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count], .cart-item-count, .js-cart-count')
          .forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------ button states */

  function setState(btn, state) {
    if (!btn) return;
    btn.classList.remove('is-loading', 'is-added', 'is-error');
    if (state) btn.classList.add('is-' + state);
    btn.disabled = state === 'loading';
    btn.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
  }

  /* ------------------------------------------------------------ the flow */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-ec-cta-form]');
    if (!form) return;

    event.preventDefault();

    var btn = form.querySelector('[data-ec-add]') || form.querySelector('button[type="submit"]');
    if (btn && btn.disabled) return;

    var body = new FormData(form);
    body.delete('return_to');

    var dawn = document.querySelector('cart-drawer');
    if (dawn && typeof dawn.getSectionsToRender === 'function') {
      try {
        body.append('sections', dawn.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      } catch (e) {}
    }

    setState(btn, 'loading');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || json.message || 'Add to cart failed');

        setState(btn, 'added');
        refreshCount();

        // Some cart apps open their drawer themselves as soon as /cart/add.js
        // resolves. Give them a moment, and only then open it ourselves.
        window.setTimeout(function () {
          if (drawerIsOpen()) { log('drawer already open — nothing to do'); return; }
          openExistingDrawer(json);
        }, 250);

        window.setTimeout(function () { setState(btn, null); }, 2200);
      })
      .catch(function (error) {
        setState(btn, 'error');
        if (window.console) console.warn('[Ease Cushion] add to cart:', error);
        window.setTimeout(function () { setState(btn, null); }, 2600);
      });
  });
})();